.screen {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 60px;
}
.summary {
  width: 400px;
  padding: 44px 40px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.badge {
  width: 88px;
  height: 88px;
  margin: 22px 0 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--color-success-100);
  color: var(--color-success);
  box-shadow: 0 8px 20px rgba(22, 163, 74, 0.18);
}
.badgeWarning {
  background: var(--color-danger-100);
  color: var(--color-danger);
  box-shadow: 0 8px 20px rgba(220, 38, 38, 0.18);
  font-family: var(--font-heading);
  font-weight: 800;
  font-size: 48px;
}
.warningKicker {
  color: var(--color-danger-700);
}
.title {
  margin: 0 0 10px;
  font-size: 68px;
  font-weight: 800;
  line-height: 1.02;
  color: var(--color-text);
}
.message {
  margin-bottom: 20px;
  font-size: 15px;
  color: var(--color-neutral-700);
  font-weight: 600;
  line-height: 1.5;
}
.side {
  display: flex;
  flex-direction: column;
  gap: 26px;
}
.report {
  width: 440px;
  padding: 28px 30px;
}
.reportHeading {
  margin-bottom: 12px;
}
.rows {
  display: flex;
  flex-direction: column;
  margin: 0;
}
.row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: 14px 0;
  border-bottom: 1px solid var(--color-neutral-100);
}
.row dt {
  font-size: 13px;
  color: var(--color-neutral-500);
  font-weight: 600;
}
.row dd {
  margin: 0;
  font-family: var(--font-heading);
  font-weight: 800;
  font-size: 19px;
  color: var(--color-text);
  font-variant-numeric: tabular-nums;
}
.actions {
  display: flex;
  gap: 28px;
}
.next {
  flex: 1;
  box-shadow: var(--shadow-sm);
  transition:
    transform 0.15s,
    box-shadow 0.15s;
}
.next:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}
.next:active {
  transform: translateY(0);
  box-shadow: var(--shadow-sm);
}
